import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2'
import { Utilityservice } from 'src/app/views/utility/utilityservice.service';
import { Table } from 'primeng/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserLogService } from './userLog.service';
import { GlobalMessage } from '../../utility/modals';
import { Router } from '@angular/router';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';

@Component({
  selector: 'app-userLog',
  templateUrl: './userLog.component.html',
  styleUrls: ['./userLog.component.css']
})

export class userLogComponent implements AfterViewInit, OnInit {
  currentPageIndex: number = 0;
  filter_string: string;
  sort_field: string;
  openModal() {
    if (this.filterdata.logtype == "") {
      Swal.fire("Please select Log type!", "", "info");
    } else { this.userlogModal = true }
  }
  location_data: any;
  customsort: boolean = true;
  from_date_data: any;
  logtype_data: any;
  to_date_data: any;
  user_data: any;
  department_data: any;

  // customSort(event: SortEvent) {
  //   event.data.sort((data1, data2) => {
  //     let value1 = data1[event.field];
  //     let value2 = data2[event.field];
  //     let result = 0;

  //     const isDate = (date) => !isNaN(Date.parse(date));
  //     if (event.field === 'senton' || event.field === 'createdon' || event.field === 'downloadedon') {
  //       if (value1 == null && value2 != null) result = -1;
  //       else if (value1 != null && value2 == null) result = 1;
  //       else if (value1 == null && value2 == null) result = 0;
  //       else if (isDate(value1) && isDate(value2)) {
  //         const date1 = new Date(value1);
  //         const date2 = new Date(value2);
  //         result = date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
  //       } else {
  //         result = value1.localeCompare(value2);
  //       }
  //     } else {
  //       if (value1 == null && value2 != null) result = -1;
  //       else if (value1 != null && value2 == null) result = 1;
  //       else if (value1 == null && value2 == null) result = 0;
  //       else if (typeof value1 === 'string' && typeof value2 === 'string') {
  //         result = value1.localeCompare(value2);
  //       } else {
  //         result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
  //       }
  //     }

  //     return event.order * result;
  //   });
  // }

  userlogDataExcel() {
              this.spinner.show();
    if ((this.filterdata.location != null) && (this.filterdata.location != undefined)) {
      this.location_data = this.filterdata.location;
    } else {
      this.location_data = "0";
    }
    if ((this.filterdata.user != null) && (this.filterdata.user != undefined)) {
      this.user_data = this.filterdata.user;
    } else {
      this.user_data = "0";
    }
    if ((this.filterdata.department != null) && (this.filterdata.department != undefined)) {
      this.department_data = this.filterdata.department;
    } else {
      this.department_data = "0";
    }
    if ((this.filterdata.logtype != null) && (this.filterdata.logtype != undefined)) {
      this.logtype_data = this.filterdata.logtype;
    } else {
      this.logtype_data = "0";
    }
    if ((this.filterdata.from_date != null) && (this.filterdata.from_date != undefined)) {
      this.from_date_data = this.filterdata.from_date;
    } else {
      this.from_date_data = "0";
    }
    if ((this.filterdata.to_date != null) && (this.filterdata.to_date != undefined)) {
      this.to_date_data = this.filterdata.to_date;
    } else {
      this.to_date_data = "0";
    }
    var data = {
      "location": this.location_data,
      "user": this.user_data,
      "department": this.department_data,
      "logtype": this.logtype_data,
      "from_date": this.from_date_data,
      "to_date": this.to_date_data
    }
    this.userLogService.userlog_data_excel(data).subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'User-Access-Log.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.userlogModal = false;
          this.spinner.hide();
      Swal.fire('User Access Log downloaded successfully!', '', 'success');
    }, error => {
          this.spinner.hide();
      Swal.fire('Something went wrong', '', 'error');
    });
  }


  index: number;

  tableData: any[] = [];
  commonScrollHeight: any;
  bulkModal: boolean;
  filedata: any;
  message: any;
  result: any;
  userlogModal = false;
  customSortField = '';

  getData(event: LazyLoadEvent) {

    let page = event.first / event.rows + 1;
    this.userLogService.filtersObservable.subscribe(res => {
      res.page = page
      res.size = event.rows;
      res['filters'] = event.filters;
      res['sortField'] = event.sortField;
      res['sortOrder'] = event.sortOrder;
      this.filterdata = res;
      if (res.logtype === 6)
      {
        this.customSortField = "senton";
      }
      else if (res.logtype === 5 || res.logtype === 4|| res.logtype === 3)
      {
        this.customSortField = "downloadedon";
      }
      else if (res.logtype === 1 || res.logtype === 2)
      {
        this.customSortField = "createdon";
      }
      if((event.sortField=="senton")||(event.sortField=="createdon")||(event.sortField=="")){
      this.filterdata.sortField = this.customSortField;}else{
       this.filterdata.sortField = event.sortField;  
      }
      this.getDataWithfilter(this.filterdata);
    });
  }

  @ViewChild('dt') dt: Table;
  componantName: string = 'task';
  ref: DynamicDialogRef | undefined;
  filterdata: any
  user: any;
  location: any;
  department: any;
  userlogData: Array<any> = [];
  visible: boolean = false;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  isActivefilter = false
  options = [
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 30, value: 30 }
  ];
  paginatorArray
  items: MenuItem[] | undefined;
  exceldownloadModal = false;
  taskfullbackupModal = false;
  delete_modal = false;
  cols = [];
  _selectedColumns = [];
  excel_paragraph = '';
  globalmessage: GlobalMessage = new GlobalMessage();
  constructor(private userLogService: UserLogService, private route: Router, public dialogService: DialogService, public utilityservice: Utilityservice,
    private utilityserv: Utilityservice, private elRef: ElementRef, private spinner: NgxSpinnerService, public PagehelpmodalService: PagehelpmodalService) {
    this.excel_paragraph = this.globalmessage.downloadexcel_text;

    this.utilityserv.refreshfilter.subscribe(res => {
      if (res == 'reset') {
        //  this.dynamiccols();
        this.isActivefilter = false
      }
    })

  }
  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isActivefilter = false;
    }
  }



  showTableColumns() {
    this.isActivefilter = !this.isActivefilter;
  }

  ngAfterViewInit() {
    this.componantName = 'Value from parent';
  }

  showDialog() {
    this.exceldownloadModal = true;
  }
  closedpop() {
    this.visible = false
  }
  handleDialogClose() {
    this.filedata = [];
  }
  getselectfiles(event) {
    this.filedata = event
  }
  showBulkUploadDialog() {
    this.bulkModal = true;
  }

  ngOnInit() {

  }

  getDataWithfilter(filterdata: any) {

  const size_value = filterdata.size;
  const page_value = filterdata.page;

  const isSearch = filterdata.filters && Object.keys(filterdata.filters).length > 0;

  if ((filterdata.from_date != '' && filterdata.to_date != '') || 
      (filterdata.from_date == '' && filterdata.to_date == '')) {

    if (filterdata.logtype != "") {

      if (!isSearch) {
        this.spinner.show();
      }

      this.userLogService.count_userlog_data(filterdata).subscribe((data: any) => {

        if (data.length > 0) {

          this.userLogService.get_filtered_userlog_data(filterdata).subscribe((data) => {

            this.dynamiccols(filterdata.logtype.toString());
            this.tableData = data.userlogdata;

for (let m = 0; m < data.userlogdata.length; m++) {
  data.userlogdata[m].sno = ((page_value - 1) * size_value) + m + 1;
}
//alert(filterdata.sortField);
if (filterdata.sortField === 'sno') {
  this.tableData.sort((a, b) => {
    return filterdata.sortOrder === 1 ? a.sno - b.sno : b.sno - a.sno;
  });
}

            this.totalRecords = data.totalcount;
            this.options = this.utilityserv.getOptionDropdown(this.totalRecords);
            this.paginatorArray = this.options.map(e => e.value);
            this.paginatorArray.sort((a, b) => a - b);
              if (filterdata.sortField) {
                this.utilityserv.sortData(filterdata.sortField, filterdata.sortOrder,this.tableData);
              }
              if(filterdata.filters){ 
             this.tableData = this.utilityserv.columnFilter(filterdata,this.tableData);
              }
            // if (filterdata.filters) {
            //   this.tableData = this.utilityserv.columnFilter(filterdata, this.tableData);
            // }

            if (!isSearch) {
              this.spinner.hide();
            }

          }, error => {
            this.showError(error);
          });

        }

      }, error => {
        this.showError(error);
      });

    } else {
      this.tableData = null;
      this.totalRecords = 0;
      this.dynamiccols("");
      this.spinner.hide();
    }
  }
}
showError(error: any) {
  const timestamp = new Date().toLocaleString();
  Swal.fire({
    title: error?.error?.error || 'Error',
    text: `This event occurred at: ${timestamp}`,
    icon: 'error'
  });
  this.spinner.hide();
}
//   getDataWithfilter(filterdata: any) {
//     const size_value = filterdata.size;
//     const page_value = filterdata.page;
//     if((filterdata.from_date!='' && filterdata.to_date!='')||(filterdata.from_date=='' && filterdata.to_date=='')){
//     if (filterdata.logtype != "") {
//       this.spinner.show();
//       this.userLogService.count_userlog_data(filterdata).subscribe((data: any) => {
//         if (data.length > 0) {
//           this.userLogService.get_filtered_userlog_data(filterdata).subscribe((data) => {
//             this.dynamiccols(filterdata.logtype.toString());
//             this.tableData = data.userlogdata;
//             if(data.userlogdata.length){
//             for (let m = 0; m < data.userlogdata.length; m++) {
//               data.userlogdata[m].sno = ((page_value - 1) * size_value) + m + 1;
//             }}
//             this.totalRecords = data.totalcount;
//             this.options = this.utilityserv.getOptionDropdown(this.totalRecords);
//             this.paginatorArray = this.options.map(e => e.value);
//             // if (filterdata.sortField) {
//             //   this.utilityserv.sortData(filterdata.sortField, filterdata.sortOrder, this.tableData);
//             // }
// this.paginatorArray.sort((a, b) => a - b);
//             if (filterdata.filters) {
//               this.tableData = this.utilityserv.columnFilter(filterdata, this.tableData);
//             }
//             this.spinner.hide();
//           }, error => {
//             const timestamp = new Date().toLocaleString(); // example timestamp
//             Swal.fire({
//               title: error.error.error,
//               text: `This event occurred at: ${timestamp}`,
//               icon: 'error'
//             })
//               this.spinner.hide();
//           });
//         }
//       }, error => {

//         const timestamp = new Date().toLocaleString();
//         Swal.fire({
//           title: error.error.error,
//           text: `This event occurred at: ${timestamp}`,
//           icon: 'error'
//         })
//           this.spinner.hide();
//       });}
//     } else {
//       this.tableData = null;
//       this.totalRecords = 0;
//       this.dynamiccols("");
//       this.spinner.hide();
//     }
//   }

  getList() {
    this.userLogService.get_all_userlogdata().subscribe((data) => {
      this.tableData = data;
      this.options = this.utilityserv.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
    });
  }

  handlePageChange(event: any) {
    this.rows2 = event.rows;
    this.currentPageIndex = event.first;
  }

  dynamiccols(type) {
    if ((type == '2') || (type == '1')) {
      this.sort_field = "createdon";
      this.cols = [
        { field: "sno", header: "S.No", type: 'text', sort: true, filter: true, width: '5%', isChecked: true, class: 'otherheader' },
        { field: "name", header: "Name", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
        { field: "emailaddr", header: "Email", type: 'text', sort: true, filter: true, width: '17%', isChecked: true, class: 'otherheader' },
        { field: "departmentname", header: "Department", type: 'text', sort: true, filter: true, width: '17%', isChecked: true, class: 'otherheader' },
        { field: "locationname", header: "Location", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
        { field: "createdon", header: "Date/Time", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
        { field: "remarks", header: "Log Type", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
      ]
    } else if ((type == '3') || (type == '4') || (type == '5')) {
      this.sort_field = "downloadedon";
      this.cols = [
        { field: "sno", header: "S.No", type: 'text', sort: true, filter: true, width: '5%', isChecked: true, class: 'otherheader' },
        { field: "filename", header: "File Name", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
        { field: "moduletype", header: "Downloaded From", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
        { field: "downloadby", header: "Downloaded By", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
        { field: "downloadedon", header: "Downloaded On", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
        { field: "eventname", header: "Log Type", type: 'text', sort: true, filter: true, width: '15%', isChecked: true, class: 'otherheader' },
      ]
    }
    else if (type == '6') {
      this.sort_field = "senton";
      this.cols = [
        { field: "sno", header: "S.No", type: 'text', sort: true, filter: true, width: '5%', isChecked: true, class: 'otherheader' },
        { field: "emailto", header: "Email To", type: 'text', sort: true, filter: true, width: '33%', isChecked: true, class: 'otherheader' },
        { field: "subject", header: "Email Subject", type: 'text', sort: true, filter: true, width: '33%', isChecked: true, class: 'otherheader' },
        { field: "senton", header: "Sent On", type: 'text', sort: true, filter: true, width: '33%', isChecked: true, class: 'otherheader' },
      ]
    } else {
      this.cols = []
    }
    this._selectedColumns = this.cols;
  }

}





